import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            login: null,
            password: null
        }
    }

    onChangeLogin = (e) => {
        this.setState({login: event.target.value});
    }

    onChangePassword = (e) => {
        this.setState({password: event.target.value});
    }

    tryLogin = () => {
        this.props.app.tryLogin(this.state.login, this.state.password);
        window.location.replace("/");
    }

    render() {
        return (
            <div className="col-md-5" style={{margin: '0 auto'}}>
                <Form>
                    <h3>Авторизация</h3>
                    <Form.Group>
                        <Form.Control name="login" onChange={this.onChangeLogin} placeholder="Логин"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Control name="password" onChange={this.onChangePassword} placeholder="Пароль"/>
                    </Form.Group>
                    <Form.Group>
                        <Button onClick={this.tryLogin}>Войти</Button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js